import React, { useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { cx } from '@emotion/css';
import { useReactiveVar } from '@apollo/client';

import { StoreInfo } from '../../../../../common';
import { AppointmentCheckStepProps } from './appointment-check-step.models';
import { useStyles } from './appointment-check-step.styles';
import { Button } from '../../../../../common/button-new';
import { setCvTerms, setRegStep } from '../../../../../../graphql';
import { getButtonStyle } from '../../utils/get-button-style';
import { ButtonColorStyle } from '../../../../../common/button-new/button.models';
import { getConfirmTitle } from '../../utils/get-confirm-title';

export const AppointmentCheckStep = ({
  onGoToPicker, pickedDate, storeInfo, ecpService,
}: AppointmentCheckStepProps): JSX.Element => {
  const classes = useStyles();
  const {
    name,
    rating,
    type,
    distance,
    street,
    openinghours,
    phonenumber,
    detailedLocation,
  } = storeInfo;
  const points = useReactiveVar(setCvTerms)?.points;

  useEffect((): void => {
    setRegStep(2);
  }, [setRegStep]);

  const changeStyle = useMemo((): ButtonColorStyle => {
    return getButtonStyle(ecpService, true);
  }, [ecpService]);

  const title = useMemo((): string => {
    return getConfirmTitle(ecpService);
  }, [ecpService]);

  return (
    <div className={classes.root}>
      <h2 data-testid="appointment-check-step-title" className={cx(classes.title, 'title-bold')}>
        <FormattedMessage id={title} />
      </h2>
      <div className={classes.section}>
        <StoreInfo
          name={name}
          rating={rating}
          type={type}
          distance={distance}
          street={street}
          detailedLocation={detailedLocation}
          phonenumber={phonenumber}
          openinghours={openinghours}
          titleStyles={cx(classes.subtitle, 'title-bold')}
          contentStyles={classes.storeContent}
        />
        <p className={classes.helperText}>
          <FormattedMessage id="appointmentRegistration.appointmentCheckStep.disclaimer" />
        </p>
      </div>
      <div className={cx(classes.section, classes.withBorder)}>
        <div className={classes.subtitleRow}>
          <h3 className={cx(classes.subtitle, 'title-bold')}>
            <FormattedMessage id="appointmentRegistration.appointmentCheckStep.fittingsDate.title" />
          </h3>
          <Button
            onClick={onGoToPicker}
            testId="change-date-button"
            style={changeStyle}
          >
            <FormattedMessage id="common.change" />
          </Button>
        </div>
        <p className={classes.description}>
          {pickedDate}
        </p>
        <p className={classes.helperText}>
          <FormattedMessage
            id="appointmentRegistration.appointmentCheckStep.fittingsDate.helperText"
          />
        </p>
      </div>
      <div className={cx(classes.section, classes.withBorder)}>
        <h3 className={cx(classes.subtitle, 'title-bold')}>
          <FormattedMessage
            id="appointmentRegistration.appointmentCheckStep.bonus.title"
          />
        </h3>
        <p className={classes.description}>
          <FormattedMessage
            id="appointmentRegistration.appointmentCheckStep.bonus.points"
            values={{ points }}
          />
        </p>
        <p className={classes.helperText}>
          <FormattedMessage id="appointmentRegistration.appointmentCheckStep.bonus.text" />
        </p>
      </div>
    </div>
  );
};
